export default __webpack_public_path__ + "static/media/a023-short6.2d45bf53.jpg";